import { useTranslation } from 'react-i18next';

import { FormCheckbox, FormInput, Skeleton, useProductsContext } from 'components';

const GiftcardsFilters = () => {
  const { t } = useTranslation();
  const { loadingGiftcardCategories, giftcardCategories } = useProductsContext();

  return (
    <>
      <div className="p-6 pb-0 lg:border-b lg:border-gray-200">
        <FormInput
          name="keywords"
          label={t('form:search')}
          placeholder={t('form:placeholders.searchGiftcard')}
          className="search-input mb-6"
        />

        <div className="submit-container pb-6 lg:!px-0">
          <button type="submit" className="btn secondary w-full uppercase" disabled={loadingGiftcardCategories}>
            {t('buttons.search')}
          </button>
        </div>
      </div>

      <div className="p-6 pb-40 lg:pb-6">
        <fieldset>
          <legend className="text-sm font-semibold uppercase mb-6">{t('form:categoryGiftcard')}</legend>

          {loadingGiftcardCategories &&
            Array.from({ length: 6 }).map((_, index) => (
              <div className="flex items-center gap-2" key={`category-skeleton-${index}`}>
                <Skeleton size="xs" classNames="!w-5 !h-5" />
                <Skeleton classNames="!w-3/5 h-8" />
              </div>
            ))}

          {!loadingGiftcardCategories &&
            giftcardCategories?.data?.map((category, index) => (
              <FormCheckbox
                key={`giftcard-category-${index}`}
                name="category"
                customLabel={() => category.name}
                className="mb-6 last:mb-0"
                value={`${category.slug}`}
              />
            ))}
        </fieldset>
      </div>
    </>
  );
};

export default GiftcardsFilters;
